enum ParentshipTypeEnum {
  Father = 1,
  Mother = 2,
  Custodian = 3,
}

export default ParentshipTypeEnum;
